// ============================================================================
// ORDERS · Collection — which product a photo belongs to (CLB-002)
// ============================================================================
// Every Collection photo renders through ProductImg (CollectionPhoto.js): our
// product-images mirror by barcode first, then the same-origin /img proxy. The
// mirror needs the barcode, and the repeat's model photo arrives without one —
// the SQL picks it out of the colours (collection-c8-v1 L837/838/906: top_photo
// from `planned`, any_photo from planned + planned_out, the master's photo from
// the rows behind `catalog_colours`), so the barcode is recovered here by
// matching the URL string against the colours the row already carries.
// Never guessed: no match → null, and ProductImg goes straight to /img.
// ============================================================================

/** A real product barcode (sales_data_master.barcode: digits only) as text, else null.
 *  The new-colour tiles' `new-<i>` and the placeholder tile's `none` are not barcodes. */
export function realBarcode(v) {
  if (v == null) return null;
  const t = String(v);
  return /^\d+$/.test(t) ? t : null;
}

const imageOf = (c) => (c && (c.image_small || c.imageSmall || c.image)) || null;

/** photoRef(url, candidates) → { src, barcode }. `src` is the url unchanged (ProductImg rewrites
 *  it); `barcode` is the first candidate's whose picture IS that url, else null. */
export function photoRef(url, candidates) {
  if (!url) return { src: null, barcode: null };
  const hit = (candidates || []).find((c) => imageOf(c) === url && realBarcode(c.barcode));
  return { src: url, barcode: hit ? realBarcode(hit.barcode) : null };
}

/** Every colour a repeat row carries — the candidates its model photo was picked from. */
export function repeatColours(r) {
  const x = r || {};
  const arr = (v) => (Array.isArray(v) ? v : []);
  return [...arr(x.planned), ...arr(x.planned_out), ...arr(x.catalog_colours), ...arr(x.sales)];
}

/** The barcode behind a repeat's picture (its model photo, or a tile's), else null. */
export const repeatPhotoBarcode = (r, url) => photoRef(url, repeatColours(r)).barcode;

/** A lightbox / gallery item's barcode: its own `barcode` (a model photo resolved where the item is
 *  built), else a repeat colour's `id` (listLightbox, repeatDrawerFacts — the barcode). Sheet, dev
 *  and new-card items have none. */
export const itemBarcode = (item) => (!item ? null
  : item.barcode !== undefined ? realBarcode(item.barcode)
    : item.kind === 'repeat' ? realBarcode(item.id) : null);
